<template>
    <v-contain>
        base update
    </v-contain>
</template>

<script>
export default {

}
</script>

<style>

</style>